export default {_name:'checkbox.group',module:'Field',view:'Element/Field/Group/Check'}